import { Toaster as Sonner } from 'sonner';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      className="toaster group text-left"
      richColors
      theme="light"
      position="bottom-right"
      {...props}
    />
  );
};

export { Toaster };
